import { api } from 'common';

import {
  ExportAuthorizationStatusVariant,
  ExportAuthorizationStatusVariantV2,
} from './Variants/ExportAuthorizationStatus';
import { ExportAuthorizationSubmissionVariant } from './Variants/ExportAuthorizationSubmission';
import { ExportCareGapFindingsVariant } from './Variants/ExportCareGapFindings';
import { ExportFormsVariant } from './Variants/ExportForms';
import { ExportGeneralCommentVariant } from './Variants/ExportGeneralComment';
import { ExportHccFindingsVariant } from './Variants/ExportHccFindings';
import { ExportNoticeOfAdmissionVariant } from './Variants/ExportNoticeOfAdmission';
import { ExportNoticeOfAdmissionStatusVariant } from './Variants/ExportNoticeOfAdmissionStatus';
import { ExportPatientCareProvidersVariant } from './Variants/ExportPatientCareProviders';
import { ExportPatientInsuranceInformation } from './Variants/ExportPatientInsuranceInformation';
import { ExportPrevisitPlanningVariant } from './Variants/ExportPrevisitPlanning';
import { ExportReferralDocumentVariant } from './Variants/ExportReferralDocument';
import { ExportReferralOrderVariant } from './Variants/ExportReferralOrder';
import { ExportScheduledAppointment } from './Variants/ExportScheduledAppointment';
import { ExportSocialHistoryVariant } from './Variants/ExportSocialHistory';
import { ExtractAuthorizationStatusVariant } from './Variants/ExtractAthorizationStatus';
import { ExtractMedicalNecessityVariant } from './Variants/ExtractMedicalNecessity';
import { ExtractPatientInsuranceVariant } from './Variants/ExtractPatientInsurance';
import { type AsynchronousJobVariant } from './Variants/common';

import JobKind = api.RpaJob.Kind;

export const ASYNCHRONOUS_JOB_VARIANTS: Partial<Record<JobKind, AsynchronousJobVariant>> = {
  [JobKind.ExportAuthorizationStatus]: ExportAuthorizationStatusVariant,
  [JobKind.ExportAuthorizationStatusV2]: ExportAuthorizationStatusVariantV2,
  [JobKind.ExportAuthorizationSubmission]: ExportAuthorizationSubmissionVariant,
  [JobKind.ExportCareGapFindings]: ExportCareGapFindingsVariant,
  [JobKind.ExportForms]: ExportFormsVariant,
  [JobKind.ExportHccFindings]: ExportHccFindingsVariant,
  [JobKind.ExportNoticeOfAdmission]: ExportNoticeOfAdmissionVariant,
  [JobKind.ExportNoticeOfAdmissionStatus]: ExportNoticeOfAdmissionStatusVariant,
  [JobKind.ExportPatientCareProviders]: ExportPatientCareProvidersVariant,
  [JobKind.ExportPatientInsuranceInformation]: ExportPatientInsuranceInformation,
  [JobKind.ExportPrevisitPlanning]: ExportPrevisitPlanningVariant,
  [JobKind.ExportReferralDocument]: ExportReferralDocumentVariant,
  [JobKind.ExportReferralOrder]: ExportReferralOrderVariant,
  [JobKind.ExtractMedicalNecessity]: ExtractMedicalNecessityVariant,
  [JobKind.ExtractUpcomingPatientInsurance]: ExtractPatientInsuranceVariant,
  [JobKind.ExtractAuthorizationStatus]: ExtractAuthorizationStatusVariant,
  [JobKind.ExportGeneralComment]: ExportGeneralCommentVariant,
  [JobKind.ExportScheduledAppointment]: ExportScheduledAppointment,
  [JobKind.ExportSocialHistory]: ExportSocialHistoryVariant,
};
